import { render, staticRenderFns } from "./InterestBlock.vue?vue&type=template&id=dd8af298&lang=pug&"
import script from "./InterestBlock.vue?vue&type=script&lang=js&"
export * from "./InterestBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports